import React from "react";
import { Group, ActionIcon, Text } from "@mantine/core";
import { FaCalendarDays } from "react-icons/fa6";
import { IoMdShare } from "react-icons/io";
import { MdRemoveRedEye } from "react-icons/md";

const dateShareReviewComponents = [
  {
    key: "postedDate",
    icon: <FaCalendarDays />,
    label: "Posted Date",
  },
  {
    key: "shares",
    icon: <IoMdShare className="text-base md:text-xl" />,
    label: "Shares",
  },
  {
    key: "reads",
    icon: <MdRemoveRedEye />,
    label: "Reads",
  },
];

const DateShareReview = ({ pageData, articleStats }) => {
  return (
    <Group gap={"xl"} className="gap-2 md:gap-3">
      {dateShareReviewComponents.map(({ key, icon, label }) => {
        const value = pageData?.dateShareReview?.[key];
        if (!value) return null;

        return (
          <Group gap="xs" key={key}>
            <ActionIcon
              variant="filled"
              color="yellow"
              radius="xl"
              aria-label={label}
              className="w-2 md:w-4"
            >
              {icon}
            </ActionIcon>
            <Text className="text-xs md:text-base">
              {key !== "postedDate" ? `${articleStats?.[key]} ${label}` : value}
            </Text>
          </Group>
        );
      })}
    </Group>
  );
};

export default DateShareReview;
